class Condition {
    constructor() {
    }
}

export default Condition;